export const MANUAL = 'manual'

export const REDIRECT = 'redirect'
